import { Article, stepInfo } from '../../../mocks/articles';

interface ArticleHeaderProps {
  article: Article;
}

export default function ArticleHeader({ article }: ArticleHeaderProps) {
  const step = stepInfo[article.step];

  return (
    <header className="mb-8">
      {/* Breadcrumb with Schema.org microdata */}
      <nav
        aria-label="パンくずリスト"
        className="flex items-center gap-1.5 text-xs text-[#A0A0A0] mb-6"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        <span itemScope itemProp="itemListElement" itemType="https://schema.org/ListItem">
          <a href="/" className="hover:text-[#8FA882] transition-colors" itemProp="item">
            <span itemProp="name">ホーム</span>
          </a>
          <meta itemProp="position" content="1" />
        </span>
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
        <span itemScope itemProp="itemListElement" itemType="https://schema.org/ListItem">
          <a href="/#content" className="hover:text-[#8FA882] transition-colors" itemProp="item">
            <span itemProp="name">家づくりガイド</span>
          </a>
          <meta itemProp="position" content="2" />
        </span>
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
        <span itemScope itemProp="itemListElement" itemType="https://schema.org/ListItem">
          <span className="text-[#6B6B6B]" itemProp="name">{article.category}</span>
          <meta itemProp="position" content="3" />
        </span>
      </nav>

      {/* Step Badge */}
      <div className="flex items-center gap-3 mb-4">
        <span
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold"
          style={{ backgroundColor: step?.bgColor, color: step?.color }}
        >
          <i className={step?.icon} aria-hidden="true" />
          STEP {article.step}｜{step?.label}
        </span>
        <time dateTime={article.date} className="text-[#A0A0A0] text-xs">{article.date}</time>
        <span className="text-[#A0A0A0] text-xs flex items-center gap-1">
          <i className="ri-time-line" aria-hidden="true" />
          {article.readTime}
        </span>
      </div>

      {/* Title - H1 for SEO */}
      <h1 className="text-2xl md:text-3xl font-bold text-[#2C2C2C] leading-snug mb-5">
        {article.title}
      </h1>

      {/* Tags */}
      <div className="flex flex-wrap gap-1.5 mb-8" role="list" aria-label="タグ一覧">
        {article.tags.map((tag) => (
          <span
            key={tag}
            role="listitem"
            className="px-2.5 py-1 rounded-md bg-[#F5F1ED] text-[#8A7040] text-xs"
          >
            #{tag}
          </span>
        ))}
      </div>

      {/* Hero Image - eager load for LCP */}
      <div className="w-full h-56 md:h-72 rounded-2xl overflow-hidden bg-[#EDEAE6]">
        <img
          src={article.image}
          alt={article.title}
          loading="eager"
          decoding="sync"
          fetchPriority="high"
          width="900"
          height="400"
          className="w-full h-full object-cover object-center"
        />
      </div>
    </header>
  );
}
